import React from 'react';
import { Button } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(Button)();
